var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"flex-column"},[_c('small',{staticClass:"text"},[_vm._v("powered by")]),_c('updox-logo',{attrs:{"qa-id":"updoxLogo"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }